/* assets/pdp.js: the product page's buy section, variant D, round ten (decision 129). Ported on 2026-10-14 from
   _ab-pdp/d.js and loaded by sections/product-buy.liquid, which is the home page's buy section as well since later that
   day (the hero's rating line takes the pill's handler there, below). It keeps only what is D's own: the viewer (the photographs
   large, and the supplement facts label under the six actives), the rows, the rating pill opening the Reviews row,
   the How to use row's two tabs (round eight), the sticky fit of the two desktop columns, and the chosen card's look
   (.is-on).
   PORT: D's harness printed every figure through MOGPDP.on, changed the choice with MOGPDP.set and added with
   MOGPDP.add. In the theme those are the live card's: Liquid prints every price from the store, assets/product.js
   (which finds this section by [data-buy-root]) keeps the prices, the hidden id, the selling plan and the button's
   price in step with the radios, and the Add to cart button is the product form's real submit, which assets/cart.js
   posts and answers with the drawer. So no price, no id and no plan is touched here.
   This file is deferred, so it runs after product.js; its change listener on the section is added after
   product.js's, so the chosen card is read after product.js has had its say (a size with no plan moves the choice
   to One-time without an event of its own).
   Every module guards on its own root: no section, nothing runs.

   D's own note, verbatim:
   _ab-pdp/d.js: variant D, "Gallery grid and floating card" (harness only, 2026-10-14).
   Prints every figure through MOGPDP.on, changes the choice with MOGPDP.set and adds with MOGPDP.add; no price is
   typed here. Also: the rating pill opens the Reviews row, a row keeps its summary where it was when it opens, the
   viewer shows any photograph large, and the sticky fit keeps whichever desktop column is shorter in view. */
(function () {
  'use strict';
  var root = document.querySelector('.pdp');
  if (!root) return;
  function $(s, el) { return (el || root).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); }

  /* ---- the chosen card: the box whose radio is checked carries .is-on (Liquid printed the first state) ---- */
  function chosen() {
    $$('.pdp-opt').forEach(function (o) {
      var r = $('.pdp-in', o);
      o.classList.toggle('is-on', !!(r && r.checked));
    });
  }
  root.addEventListener('change', chosen);
  chosen();

  /* ---- the rows ---- */
  /* the rows that open and close (round eighteen: the Reviews row is always open, a div with no summary) */
  var rows = $$('details.pdp-row');
  /* a row that opens inside a held card can move the card; keep the summary that was clicked under the pointer */
  rows.forEach(function (d) {
    var sum = $('summary', d);
    sum.addEventListener('click', function () {
      var y0 = sum.getBoundingClientRect().top;
      requestAnimationFrame(function () {
        fit();
        var dy = sum.getBoundingClientRect().top - y0;
        if (Math.abs(dy) > 1) window.scrollBy({ top: dy, left: 0, behavior: 'instant' });
      });
    });
  });

  /* PORT: the pill is [data-rev-badge], hidden until assets/reviews.js has judge.me's numbers, and the Reviews row
     exists only while settings.reviews_live is on; both are looked for before anything is bound */
  var revs = $('#pdp-reviews'), pill = $('.pdp-pill--rate');
  /* 2026-10-14 (decision 129, "Yes, match the home page"): on the home page this section follows the hero, whose rating line
     (sections/index-hero.liquid, decision 126) links to the same #reviews. It takes this handler too, so the line and the
     pill land the row the same way, with focus inside it. On the product page the pill is the only such link. */
  var toRevs = Array.prototype.slice.call(document.querySelectorAll('a[data-rev-badge][href="#reviews"]'));
  if (revs && pill && toRevs.indexOf(pill) < 0) toRevs.push(pill);
  if (revs) toRevs.forEach(function (a) { a.addEventListener('click', goRevs); });
  function goRevs(e) {
    e.preventDefault();
    revs.open = true;
    fit();
    var calm = matchMedia('(prefers-reduced-motion: reduce)').matches;
    revs.scrollIntoView({ block: 'start', behavior: calm ? 'instant' : 'smooth' });
    /* round eighteen: the Reviews row is always open and has no summary; the widget's section takes focus */
    var target = $('summary', revs) || $('#reviews', revs) || revs;
    if (!target.hasAttribute('tabindex') && target.tagName !== 'SUMMARY') target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
    /* a smooth scroll can be cancelled by the browser; if the row has not arrived, go there at once */
    setTimeout(function () {
      var top = revs.getBoundingClientRect().top;
      /* 2026-10-14: from the home page's hero (its rating line takes this handler) the smooth scroll is still running here,
         and the browser takes one more step of it after the jump, so the row landed about 40px past its scroll margin (top
         56 at 390, 61 at 1440, measured, where the pill's own scroll lands it at 96). So the jump is made twice: at once,
         and again 120ms later, when that smooth scroll has stopped; the second finds the row where it should be on any page
         where nothing was running. */
      if (top < 0 || top > window.innerHeight * 0.5) { land(); setTimeout(land, 120); }
    }, 900);
  }
  function land() {
    var margin = parseFloat(getComputedStyle(revs).scrollMarginTop) || 0;
    window.scrollTo({ top: Math.max(0, revs.getBoundingClientRect().top + window.scrollY - margin), left: window.scrollX, behavior: 'instant' });
  }

  /* round eighteen: Show fewer shrinks the stack above the button; keep the button in view once the three are back */
  var more = revs && $('.rev__all--below', revs), revGrid = revs && $('[data-rev-grid]', revs), backUp = false;
  if (more && revGrid) {
    more.addEventListener('click', function () { backUp = more.getAttribute('aria-expanded') === 'true' || /fewer/i.test(more.textContent); });
    new MutationObserver(function () {
      more.setAttribute('aria-expanded', /fewer/i.test(more.textContent) ? 'true' : 'false');
      if (backUp && !/fewer/i.test(more.textContent)) { backUp = false; more.scrollIntoView({ block: 'center' }); }
      fit();
    }).observe(revGrid, { childList: true });
  }

  /* ---- the viewer ---- */
  var dlg = $('.pdp-view');
  var vImg = $('.pdp-view__img', dlg), prev = $('.pdp-view__prev', dlg), next = $('.pdp-view__next', dlg);
  var list = [], at = 0;
  function show(i) {
    at = (i + list.length) % list.length;
    vImg.src = list[at].src;
    vImg.alt = list[at].alt;
  }
  function view(items, i, label) {
    list = items;
    dlg.setAttribute('aria-label', label);
    prev.hidden = next.hidden = items.length < 2;
    show(i);
    if (!dlg.open) dlg.showModal();
  }
  var shots = $$('.pdp-tile').map(function (b) { var im = $('img', b); return { src: im.getAttribute('src'), alt: im.alt }; });
  $$('.pdp-tile').forEach(function (b, i) { b.addEventListener('click', function () { view(shots, i, 'Product images'); }); });
  /* PORT: D opened the review photographs here too (.pv-d-pic); the live reviews open theirs in reviews.js's own viewer */
  /* the label, one tap under the six actives (round three): the same viewer, one image */
  $$('.pdp-facts').forEach(function (b) {
    b.addEventListener('click', function () { view([{ src: b.getAttribute('data-src'), alt: b.getAttribute('data-alt') }], 0, 'Supplement facts'); });
  });
  prev.addEventListener('click', function () { show(at - 1); });
  next.addEventListener('click', function () { show(at + 1); });
  $('.pdp-view__x', dlg).addEventListener('click', function () { dlg.close(); });
  dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
  dlg.addEventListener('keydown', function (e) {
    if (list.length < 2) return;
    if (e.key === 'ArrowLeft') { e.preventDefault(); show(at - 1); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); show(at + 1); }
  });

  /* ---- How to use, two tabs (round eight): click, arrow keys, Home and End; the panel not chosen is hidden ---- */
  /* PORT: D's block word for word, prefix renamed. A switch changes the card's height, so it re-fits the sticky columns. */
  var htTabs = $$('.pdp-ht__tabs [role="tab"]');
  function htPick(t, focus) {
    htTabs.forEach(function (x) {
      var on = x === t;
      x.setAttribute('aria-selected', on ? 'true' : 'false');
      x.tabIndex = on ? 0 : -1;
      document.getElementById(x.getAttribute('aria-controls')).hidden = !on;
    });
    if (focus) t.focus();
    fit();
  }
  htTabs.forEach(function (t, i) {
    t.addEventListener('click', function () { htPick(t, false); });
    t.addEventListener('keydown', function (e) {
      var k = e.key, j = null;
      if (k === 'ArrowRight') j = (i + 1) % htTabs.length;
      else if (k === 'ArrowLeft') j = (i - 1 + htTabs.length) % htTabs.length;
      else if (k === 'Home') j = 0;
      else if (k === 'End') j = htTabs.length - 1;
      if (j !== null) { e.preventDefault(); htPick(htTabs[j], true); }
    });
  });

  /* ---- the sticky fit (desktop): each column's top so that whichever is shorter holds in view; one taller than
     the window holds by its bottom edge, so nothing in it is ever stuck under the fold ---- */
  var gal = $('.pdp-gal'), col = $('.pdp-col'), wide = matchMedia('(min-width: 1000px)');
  function fit() {
    var bar = document.querySelector('.bar');
    var top = Math.round((bar ? bar.getBoundingClientRect().height : 64) + 24);
    [gal, col].forEach(function (el) {
      el.style.top = wide.matches ? Math.min(top, Math.round(window.innerHeight - el.offsetHeight - 24)) + 'px' : '';
    });
  }
  if ('ResizeObserver' in window) { var ro = new ResizeObserver(fit); ro.observe(gal); ro.observe(col); }
  window.addEventListener('resize', fit);
  if (wide.addEventListener) wide.addEventListener('change', fit);
  fit();
})();
